//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';

import { ExitConfirmationModal } from '@catalog-ingestion/components/modals/exit-confirmation-modal/ExitConfirmationModal';
import { WORKFLOW_PANELS } from '@catalog-ingestion/constants/googleCatalogIngestionModalConstants';
import { FullscreenModal } from '@components/FullscreenModal';
import styled from 'styled-components';
import {
  FlatDefaultButton,
  PrimaryButton,
} from '@components/atoms/button/Button';

interface Props {
  children: React.ReactNode;
  currentPanel: WORKFLOW_PANELS;
  lastPanel: WORKFLOW_PANELS;
  headerTitle: string;
  isOpen: boolean;
  onNext?: () => void;
  onClose?: () => void;
  onDone?: () => void;
}

export const IngestionModal = ({
  isOpen,
  headerTitle,
  onNext,
  children,
  onClose,
  onDone,
  currentPanel,
  lastPanel,
}: Props) => {
  const navigationButtons = () => {
    if (currentPanel === lastPanel) {
      return <PrimaryButton onClick={onDone}>Done</PrimaryButton>;
    } else {
      return (
        <>
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <PrimaryButton onClick={onNext}>Next</PrimaryButton>
        </>
      );
    }
  };

  return (
    <FullscreenModal
      isOpen={isOpen}
      wideLayout={true}
      onClose={onClose ?? (() => {})}
      headerTitle={headerTitle}
      actionButton={navigationButtons()}
    >
      <ExitConfirmationModal />
      {children}
    </FullscreenModal>
  );
};

const CancelButton = styled(FlatDefaultButton)`
  && {
    margin-right: ${({ theme }) => theme.spacings[2]};
  }
`;
